import { useNavigate } from "react-router-dom";
import AppLogo from "../../../../assets/images/app-logo.jpg";
import TypewriterComponent from "../../../../components/Typewriter/TypewriterComponent";

const TradeInBanner = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col justify-between items-center w-full h-full bg-[#FBFBFB] text-black pt-4">
      {/* Nội dung trên */}
      <div className="flex flex-col text-center space-y-2 lg:space-y-4 px-4 gap-2 items-center">
        <div className="flex gap-2 items-center justify-center">
          <img src={AppLogo} className="w-10 h-10" alt="Logo" />
          <div className="flex flex-col gap-0.5 items-start">
            <span className="text-md lg:text-xl font-bold text-primaryColor">
              Ly iPhone
            </span>
            <span className="text-xs font-bold text-gray-500">
              253 Hùng Vương, Tam Kỳ
            </span>
          </div>
        </div>
        <div className="flex flex-col lg:flex-row gap-1">
          <p className="text-3xl lg:text-4xl font-bold">
            Thu cũ đổi mới iPhone
          </p>
          <p className="text-4xl font-bold hidden lg:block">-</p>
          <p className="text-2xl lg:text-4xl font-bold">
            <TypewriterComponent text="Tiết kiệm đến 10 triệu" loop={true} />
          </p>
        </div>
        <p className="text-md lg:text-lg text-gray-600 mt-4">
          Đổi iPhone cũ, nhận ngay ưu đãi mua iPhone mới với giá tốt nhất!
        </p>
        {/* Nút Xem chi tiết */}
        <button
          onClick={() =>
            navigate(
              "/services-offers/djoi-cu-lay-moi-tiet-kiem-len-djoi-de-dang"
            )
          }
          className="w-28 py-2 bg-black text-white rounded-md hover:bg-gray-800 transition"
        >
          Xem chi tiết
        </button>
      </div>

      {/* Hình ảnh minh họa */}
      <div className="flex justify-center items-center w-full">
        <img
          src={
            "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759227091/iphone-trade-in_bizluq.jpg"
          }
          alt="Thu cũ đổi mới"
          className="w-full"
        />
      </div>
    </div>
  );
};
export default TradeInBanner;
